import { useEffect, lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import GameSelectPage from '@/pages/GameSelectPage';
import SettingsPage from '@/pages/SettingsPage';
import NotFoundPage from '@/pages/NotFoundPage';
import { useSettingsStore } from '@/store/settingsStore';

/** Spiele lazy-loaded — reduziert initial bundle */
const ZahlenstrahlGame = lazy(() => import('@/games/zahlenstrahl'));
const Memory3dGame = lazy(() => import('@/games/memory3d'));
const TangramGame = lazy(() => import('@/games/tangram'));
const BuchstabenGame = lazy(() => import('@/games/buchstaben'));
const RechenMonsterGame = lazy(() => import('@/games/rechen-monster'));

function LoadingFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center" data-testid="loading">
      <div className="text-4xl animate-pulse">🎮</div>
    </div>
  );
}

export default function App() {
  const darkMode = useSettingsStore((s) => s.darkMode);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-indigo-50 to-purple-50 dark:from-gray-900 dark:to-gray-800">
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route path="/" element={<GameSelectPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/games/zahlenstrahl" element={<ZahlenstrahlGame />} />
          <Route path="/games/memory3d" element={<Memory3dGame />} />
          <Route path="/games/tangram" element={<TangramGame />} />
          <Route path="/games/buchstaben" element={<BuchstabenGame />} />
          <Route path="/games/rechen-monster" element={<RechenMonsterGame />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </div>
  );
}
